import { GetServerSideProps } from 'next'
import { useRouter } from 'next/router'

import AnimatedLoadingPage from '@components/AnimatedLoadingPage'

import ScoredCardRoute from '@routes/ScoredCardRoute'
import UnscoredCardRoute from '@routes/UnscoredCardRoute'

import getIsScoredJourney from '@utils/getIsScoredJourney'

interface CardPageProps {
    isScoredJourney: boolean
}

const CardPage = ({ isScoredJourney }: CardPageProps) => {
    const router = useRouter()

    return (
        <>
            {isScoredJourney && !router.isReady ? (
                <AnimatedLoadingPage />
            ) : null}
            {isScoredJourney ? <ScoredCardRoute /> : <UnscoredCardRoute />}
        </>
    )
}

export const getServerSideProps: GetServerSideProps<CardPageProps> = async ({
    query,
    res,
}) => {
    const isScoredJourney = getIsScoredJourney(query)

    if (!isScoredJourney) {
        res.setHeader('Cache-Control', 'public, max-age=600')
    }

    return {
        props: {
            isScoredJourney,
        },
    }
}

export default CardPage
